<template>
    <v-dialog :value="value" @input="$emit('input', $event)" max-width="600">
      <v-card>
        <v-card-title class="headline">
          <v-icon left :color="planIcon.color">{{ planIcon.icon }}</v-icon>
          Upgrade to {{ planTitle }}
        </v-card-title>

        <v-card-text>
          <v-alert type="info" dense class="mb-4">
            You're about to upgrade to the {{ planTitle }} plan.
          </v-alert>

          <div v-if="selectedPlan === 'pro'">
            <h3 class="subtitle-1 mb-2">Pro Plan includes:</h3>
            <v-list dense>
              <v-list-item v-for="feature in proFeatures" :key="feature">
                <v-list-item-icon>
                  <v-icon color="success" small>mdi-check</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ feature }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>

          <div v-if="selectedPlan === 'team_pro'">
            <h3 class="subtitle-1 mb-2">Pro Team Plan includes:</h3>
            <v-list dense>
              <v-list-item v-for="feature in teamProFeatures" :key="feature">
                <v-list-item-icon>
                  <v-icon color="success" small>mdi-check</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ feature }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>

          <v-divider class="my-4"></v-divider>

          <div class="text-body-2">
            <p>
              <v-icon small left>mdi-credit-card</v-icon>
              <strong>Secure Payment:</strong> You'll be redirected to our secure payment page powered by Stripe.
            </p>
            <p>
              <v-icon small left>mdi-cancel</v-icon>
              <strong>Cancel Anytime:</strong> You can cancel your subscription at any time from your account settings.
            </p>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="$emit('input', false)"
            :disabled="loading"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            @click="$emit('confirm')"
            :loading="loading"
          >
            <span class="black--text">Continue to Payment</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>

  <script>
  export default {
    name: 'UpgradeDialog',

    props: {
      value: {
        type: Boolean,
        default: false,
      },
      selectedPlan: {
        type: String,
        default: 'pro',
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      planTitle() {
        return this.selectedPlan === 'pro' ? 'Pro' : 'Pro Team';
      },

      planIcon() {
        return this.selectedPlan === 'pro'
          ? { icon: 'mdi-star-three-points-outline', color: 'primary' }
          : { icon: 'mdi-account-group', color: 'primary' };
      },

      proFeatures() {
        return [
          'Advanced AI features and capabilities',
          'Priority customer support',
          'Unlimited projects and galaxies',
          'Enhanced search and discovery tools',
          'Export and integration features',
          'Advanced analytics and insights',
        ];
      },

      teamProFeatures() {
        return [
          'All Pro features included',
          'Team collaboration tools',
          'Centralized billing and management',
          'Team member access control',
          'Shared workspaces and resources',
          'Admin dashboard and controls',
          'Priority team support',
        ];
      },
    },
  };
  </script>
